<template>
  <div class="ob_notice">
    <!-- 搜索 -->
    <div class="oj_select">
      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
            >
              <el-form-item label="">
                <el-input v-model="selectForm.type" placeholder="搜索条件" disabled></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect" disabled>搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple-light">
            <div class="cratebtn">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="createEvents"
                >新增公告</el-button
              >
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data="getTabeData"
      border
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="news_id"
        label="公告ID"
        width="120"
      ></el-table-column>
      <el-table-column prop="title" label="公告标题"></el-table-column>
      <el-table-column prop="time" label="创建时间"> </el-table-column>
      <el-table-column prop="defunct" label="是否上线/屏蔽">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击修改当前公告的状态"
            placement="top"
          >
            <el-button
              v-if="scope.row.defunct == 'N'"
              type="success"
              @click="isDefunct(scope.row.news_id)"
              >上线中</el-button
            >
            <el-button
              v-if="scope.row.defunct == 'Y'"
              type="warning"
              @click="isDefunct(scope.row.news_id)"
              >已下线</el-button
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="220">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <el-button
              @click="handleLookClick(scope.row.news_id)"
              type="primary"
              icon="el-icon-view"
              size="small"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              type="success"
              icon="el-icon-edit"
              size="small"
              @click="handleClick(scope.row.news_id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="handleDeleteClick(scope.row.news_id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="oj_page">
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 30]"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="EditorDialogVisible"
      width="65%"
      :lock-scroll="false"
      @closed="closed('editorForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="120px"
        :model="editorForm"
        :rules="ruleForm"
        ref="editorForm"
      >
        <el-form-item label="公告ID" prop="news_id">
          <el-input v-model="editorForm.news_id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公告发布人" prop="user_id">
          <el-input v-model="editorForm.user_id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公告标题" prop="title">
          <el-input v-model="editorForm.title"></el-input>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <Editor
            v-if="EditorDialogVisible"
            ref="lookEditor"
            :heigth="250"
            :editorID="'lookEditor'"
            :html="editorForm.content"
            @change="editorChange($event, editorForm, 'content')"
          ></Editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editorSubmit('editorForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="lookEventDialogVisible"
      width="65%"
      @closed="closed('lookForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="120px"
        :model="lookForm"
        ref="lookForm"
      >
        <el-form-item label="公告ID :">
          <el-tag>{{ lookForm.news_id }}</el-tag>
        </el-form-item>
        <el-form-item label="公告发布人 :">
          <el-tag>{{ lookForm.user_id }}</el-tag>
        </el-form-item>
        <el-form-item label="公告标题 :">
          <el-tag>{{ lookForm.title }}</el-tag>
        </el-form-item>
        <el-form-item label="公告内容 :">
          <span v-html="lookForm.content">{{ lookForm.content }}</span>
        </el-form-item>
        <el-form-item label="发布时间 :">
          <el-tag>{{ lookForm.time }}</el-tag>
        </el-form-item>
        <el-form-item label="公告展示状态 :">
          <el-tag v-if="lookForm.defunct == 'N'">不屏蔽</el-tag>
          <el-tag v-if="lookForm.defunct == 'Y'">屏蔽</el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookEventDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新增的弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="createEventDialog"
      @closed="closed('createForm')"
      :lock-scroll="false"
      width="65%"
    >
      <el-form
        :model="newEventForm"
        label-width="100px"
        ref="createForm"
        :rules="ruleForm"
      >
        <el-form-item label="公告标题" prop="title">
          <el-input
            v-model="newEventForm.title"
            placeholder="请输入公告标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <Editor
            v-if="createEventDialog"
            :heigth="300"
            :editorID="'eEditor'"
            @change="editorChange($event, newEventForm, 'content')"
          ></Editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createEventDialog = false">取 消</el-button>
        <el-button type="primary" @click="createSubmit('createForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Editor from 'common/wangeditor/Editor.vue';
import { pcNoticeRules } from 'untils/form_validation.js';
import {
  initNewsList,
  findNews,
  saveNews,
  deleteNews,
  addNews,
  changeNewsDefunct
} from 'api/post/postApi.js';
export default {
  name: 'oj_notice',
  components: {
    Editor
  },
  data() {
    return {
      loading: true,
      tableData: [],
      // 分页功能参数
      total: 0,
      sizePage: 10,
      currentPage: 1,
      selectForm: {
        type: ''
      },
      EditorDialogVisible: false,
      lookEventDialogVisible: false,
      createEventDialog: false,
      lookForm: {},
      editorForm: {},
      ruleForm: null,
      newEventForm: {
        content: ''
      },
      title: ''
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initNewsList();
      this.tableData = res.data;
      this.total = res.data.length;
      this.loading = false;
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 查看
    async handleLookClick(nid) {
      this.title = '当前信息';
      const params = { id: nid };
      const { data: res } = await findNews(params);
      this.lookForm = res.data;
      this.lookEventDialogVisible = true;
    },
    // 编辑
    async handleClick(nid) {
      this.title = '公告编辑';
      this.ruleForm = pcNoticeRules;
      const params = { id: nid };
      const { data: res } = await findNews(params);
      this.editorForm = res.data;
      this.EditorDialogVisible = true;
    },

    // 编辑提交
    editorSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          const { data: res } = await saveNews(this.editorForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('更新失败！');
          } else {
            this.$message.success('更新成功！');
            this.initData();
          }
          this.EditorDialogVisible = false;
        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });
    },
    // 公用的dialog清空逻辑
    closed(formName) {
      this.editorForm = {};
      this.lookForm = {};
      this.newEventForm = { content: '' };
      this.fileList = [];
      this.resetForm(formName);
    },
    // 删除
    async handleDeleteClick(nid) {
      // 询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除！');
      }
      const params = { id: nid };
      const { data: res } = await deleteNews(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('删除失败！');
      } else {
        this.$message.success('删除成功！');
        this.initData();
      }
    },
    // 新增赛事按钮
    createEvents() {
      this.title = '新增公告';
      this.ruleForm = pcNoticeRules;
      this.createEventDialog = true;
    },
    // 提交新增表单
    createSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          const { data: res } = await addNews(this.newEventForm);

          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('新增公告失败！');
          } else {
            this.$message.success('新增公告成功！');
            this.initData();
          }
          this.createEventDialog = false;
        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });
    },
    // 清除验证规则
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 搜索实现
    onSelect() {
    },
    /**
     *监听富文本编辑器
     */
    editorChange(value, form, item) {
      form[item] = value;
    },
    async isDefunct(nid) {
      // 询问用户是否修改状态
      const confirmResult = await this.$confirm(
        '此操作将修改公告上线状态, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消修改！');
      }
      const params = { id: nid };
      const { data: res } = await changeNewsDefunct(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('修改失败！');
      } else {
        this.$message.success('修改成功！');
        this.initData();
      }
    }
  }
};
</script>

<style scoped>
.oj_page {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.imgs {
  width: 150px;
  height: 100px;
}
.z_img {
  width: 150px;
  height: 200px;
}
.img_show {
  width: 300px;
  height: 200px;
}
.cratebtn {
  float: right;
}
</style>